// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_jp-0";